<template lang="pug">
  .label
    p
      b(v-if="numero") {{ numero }}) &nbsp
      | {{ label }}
      span(v-if="required").required &nbsp *
</template>

<script>
export default {

  props: {
    label: {
      type: String,
      required: true
    },
    numero: String,
    required: {
      type: Boolean,
      default: true
    }
  }

}
</script>

<style scoped lang="scss">
@import "@/style/_variables.scss";

.label {
  padding-bottom: 5px;
  font-size: 14px;

  .required {
    color: $error;
  }
}

p {
  color: $font-dark-color !important;
  font-size: 14px;
}
</style>
